// import { Link, useParams } from "react-router-dom";

// const InternalNavigation = ({ items = [], subTabValue }) => {
//   const { id: customerId, tab: tabValue } = useParams();

//   if (!items?.length) return null;

//   return (
//     // border-b border-[#E9E9E9]
//     <div className="flex gap-2 bg-white">
//       {items.map((item) => (
//         <Link
//           key={item.value}
//           to={`/customer/${customerId}/${tabValue}/${item.value}`}
//           className={`p-2 cursor-pointer text-base font-medium ${
//             item.value === subTabValue ? "text-[#1D4469] border-b-2 border-[#1D4469]" : "text-[#888] "
//           }`}
//         >
//           {item.label}
//         </Link>
//       ))}
//     </div>
//   );
// };

// export default InternalNavigation;

import { Link, useParams, useSearchParams } from "react-router-dom";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import { getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import { ReactComponent as TrackingSvg } from "../../assets/images/icons/TrackingIcon.svg";
import { ReactComponent as NotesIcons } from "../../assets/images/icons/NotesIcons.svg";
import { ReactComponent as DocumentIcons } from "../../assets/images/icons/DocumentIcons.svg";
import { ReactComponent as TasksIcon } from "../../assets/images/icons/TasksIcon.svg";
import { ReactComponent as ModuleDash } from "../../assets/images/icons/ModuleDash.svg";

const InternalNavigation = ({ items = [], subTabValue, onSelect, disableRouting, showOnlyActive, isIcons = false }) => {
  const { id: customerId, tab: tabValue, subTab } = useParams();
  const [searchParams] = useSearchParams();

  const listView = searchParams.get("listView");

  if (!items?.length) return null;
  console.log(items, "asdCOLOR");

  const navMenu = showOnlyActive ? items.filter((item) => item.value === subTabValue) : items;

  const getIconCheck = (label) => {
    if (!label) return null;

    switch (label.toLowerCase()) {
      case "tracking":
        return <TrackingSvg />;

      case "notes":
        return <NotesIcons />;

      case "documents":
        return <DocumentIcons />;

      case "tasks":
        return <TasksIcon />;

      default:
        return <ModuleDash />;
    }
  };

  return (
    <div className={`flex  bg-white ${listView === "kanban" ? "gap-3" : "gap-1"}`}>
      {navMenu.map((item) => {
        const isActive = item.value === subTabValue;

        // If onSelect is passed, render a button
        if (disableRouting && onSelect) {
          return (
            <button
              key={item.value}
              onClick={() => onSelect(item)}
              className={`py-2 cursor-pointer text-base font-medium flex items-center justify-center gap-x-2 hover:text-primary-70 ${isActive ? "border-b-2 border-primary text-primary" : "text-[#888]"} ${listView === "kanban" ? "py-3" : "px-2"}  whitespace-nowrap   `}
              // style={
              //   isActive
              //     ? listView === "kanban"
              //       ? {
              //           color: item.color || "primary",
              //           borderColor: item.color || "primary", // kanban border matches item color
              //         }
              //       : {
              //           color: "primary",
              //           borderColor: "primary", // non-kanban border fixed color
              //         }
              //     : {}
              // }
            >
              {/* {item.label} */}
              {isIcons && getIconCheck(item.label.toLowerCase())}
              {getTitleCase(item.label) || item.label}
            </button>
          );
        }

        // Default: route-based navigation
        return (
          <Link
            key={item.value}
            to={`/customer/${customerId}/${tabValue}/${item.value}`}
            className={`p-2 cursor-pointer  font-Inter flex items-center justify-center gap-x-2 ${
              isActive ? "text-primary border-b-2 border-primary font-semibold" : "text-[#888] text-14 font-medium"
            }`}
          >
            {isIcons && getIconCheck(item.label.toLowerCase())}
            {getTitleCase(item.label) || item.label}
          </Link>
        );
      })}
    </div>
  );
};

export default InternalNavigation;
